// src/components/Preloader.jsx
import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import "./index.css";

// const HMSignatureGreyVideo = require("../../Assets/images/transparent_video.webm");
const HMSignatureGreyVideo = require("../../Assets/images/hm_signature_brown.mp4");

const Preloader = ({ onFinished }) => {
    const [isVisible, setIsVisible] = useState(true);
    const videoRef = useRef(null);

    const finishPreloader = () => {
        setIsVisible(false);
    };

    // 1. Video ends naturally → finish
    const handleVideoEnd = () => {
        finishPreloader();
    };

    // 2. User scrolls → instantly skip
    useEffect(() => {
        const handleScroll = () => {
            if (isVisible) {
                finishPreloader();
            }
        };

        // Also catch wheel, touch, and keyboard
        window.addEventListener('wheel', handleScroll, { passive: true });
        window.addEventListener('touchmove', handleScroll, { passive: true });
        window.addEventListener('keydown', (e) => {
            if (['ArrowDown', 'PageDown', ' '].includes(e.key)) {
                handleScroll();
            }
        });

        return () => {
            window.removeEventListener('wheel', handleScroll);
            window.removeEventListener('touchmove', handleScroll);
        };
    }, [isVisible]);

    // 3. When exit animation finishes → tell parent
    const handleExitComplete = () => {
        if (!isVisible && typeof onFinished === 'function') {
            onFinished();
        }
    };

    return (
        <AnimatePresence onExitComplete={handleExitComplete}>
            {isVisible && (
                <motion.div
                    id="dsn_preloader"
                    className="preloader"
                    initial={{ y: "0%" }}
                    exit={{ y: "-100%" }}
                    transition={{ duration: 1.0, ease: [0.76, 0, 0.24, 1] }}
                >
                    {/* <div className="background-section preloader-bg-main d-flex justify-content-center align-items-center dsn-bg-pattern bg-offset bg-square vh-100"> */}
                    <div className="preloader-inner">
                        <video
                            ref={videoRef}
                            autoPlay
                            muted
                            playsInline
                            onEnded={handleVideoEnd}
                            className="signature-video"
                        >
                            <source src={HMSignatureGreyVideo} type="video/mp4" />
                        </video>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Preloader;